export const TEMP_ACCESS_INVITE_OPTIONS_KEY = 'tempUsersInviteTo';
export const USER_INVITE_OPTIONS_KEY = 'inviteTo';
export function getUiNameCalculator(uiName, {
  optionsKey = TEMP_ACCESS_INVITE_OPTIONS_KEY
} = {}) {
  return ({
    user,
    methods
  }) => {
    const inviteOptions = getInviteOptions({
      user,
      methods,
      uiName,
      optionsKey
    });
    return inviteOptions?.uiName || uiName;
  };
}
export function getUiUrlCalculator(uiUrl, {
  optionsKey = TEMP_ACCESS_INVITE_OPTIONS_KEY
} = {}) {
  return ({
    user,
    methods
  }) => {
    const inviteOptions = getInviteOptions({
      user,
      methods,
      optionsKey
    });
    return inviteOptions?.url || uiUrl;
  };
}
export function getInviteOptions({
  user,
  methods,
  optionsKey = TEMP_ACCESS_INVITE_OPTIONS_KEY
}) {
  if (!user) {
    return null;
  }
  const {
    roles
  } = user;
  if (!Array.isArray(roles) || roles.length === 0) {
    return null;
  }
  let maxPriority = Number.NEGATIVE_INFINITY,
    inviteOptions;
  for (let i = 0; i < roles.length; i++) {
    const role = roles[i];
    const roleInviteOptions = role?.metadata?.[optionsKey];
    if (roleInviteOptions) {
      const rolePriority = typeof role?.metadata?.priority === 'number' ? role.metadata.priority : Number.NEGATIVE_INFINITY;
      if (rolePriority > maxPriority || inviteOptions == null) {
        inviteOptions = roleInviteOptions;
        maxPriority = rolePriority;
      }
    }
  }
  return inviteOptions;
}